<template>
  <div class="page-editor">
    <mt-header fixed title="扫码发货">
      <router-link to="/ent/sales/choose_dealer" slot="left">
        <mt-button icon="back">返回</mt-button>
      </router-link>
    </mt-header>
    <mt-field label="经销商" v-model="dealer.name" readonly></mt-field>
    <div class="item-label">
      <span>发货产品【{{pkgCodes.length}}】</span>
      <mt-button type="primary" size="small" @click.native="openWxScan">扫码</mt-button>
    </div>
    <mt-cell v-for="pcc in pkgCodes" :title="pcc.prodName" :label="pcc.pkgCode" :key="pcc.pkgCode">
      <a class="item-del" @click="removeItem(pcc.pkgCode)"></a>
    </mt-cell>

    <div class="page-btn">
      <mt-button type="danger" size="large" @click.native="doDeliver">发货</mt-button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Toast, Button, MessageBox } from "mint-ui";
import Wxmp from "@/components/wxmp";

export default {
  components: { Toast, Button },
  props: ["dealer"],
  data() {
    return {
      pkgCodes: []
    };
  },
  methods: {
    openWxScan() {
      Wxmp.config().then(() => {
        Wxmp.scanQRCode().then(result => {
          this.parseCode(result);
        });
      });
    },
    parseCode(content) {
      this.$http
        .get(
          this.GLOBAL.serverUrl +
            "/ent/dealer/deliver/check_code?pkgcode=" +
            content
        )
        .then(resp => {
          if (resp.body.code == 200) {
            this.pkgCodes.push(resp.body.data);
          } else if (resp.body.code == 500) {
            Toast(resp.body.msg || "操作失败，请稍后再试！");
          }
        });
    },
    removeItem(pcode) {
      this.pkgCodes = this.pkgCodes.filter((el, idx, arr) => {
        return el.pkgCode != pcode;
      });
    },
    doDeliver() {
      if (this.pkgCodes.length == 0) {
        return;
      }
      MessageBox.confirm("确定发货?").then(
        action => {
          this.saveDeliver();
        },
        action => {}
      );
    },
    saveDeliver() {
      var pcodes = this.pkgCodes.reduce((rtv, cv, idx) => {
        return (idx == 1 ? rtv.pkgCode : rtv) + "," + cv.pkgCode;
      });
      this.$http
        .post(this.GLOBAL.serverUrl + "/ent/dealer/deliver", {
          pkgcode: pcodes,
          dealer: this.dealer.id
        })
        .then(resp => {
          if (resp.body.code == 200) {
            Toast("发货成功！");
            this.pkgCodes = []; // 清空当前已发货数据
          } else if (resp.body.code == 500) {
            Toast(resp.body.msg || "操作失败，请稍后再试！");
          }
        });
    }
  }
  /* ,mounted() {
    var codes = [
      "159BC6DDA7E24BFCBAD9A4A351E1B492",
      "AA373D7E420A48D9B1449CBF326DB414",
      "3F266CDEB27F4F9E9A488AEC22B2C916",
      "9F08DFBCF231405CA1A1065C75052F7F"
    ];
    codes.forEach(c => {
      this.parseCode("http://cac.top/067/00/af2/" + c);
    });
  } */
};
</script>
<style scoped>
.page-editor {
  padding-top: 40px;
}
.page-btn {
  margin-top: 1rem;
  padding: 1rem;
}
.upload-field {
  position: relative;
  display: inline-block;
  background: #d0eeff;
  border: 1px solid #99d3f5;
  border-radius: 4px;
  padding: 4px;
  overflow: hidden;
  color: #1e88c7;
  text-decoration: none;
  text-indent: 0;
  line-height: 1.2rem;
}
.upload-field input {
  position: absolute;
  right: 0;
  top: 0;
  opacity: 0;
}
.upload-field:hover {
  background: #aadffd;
  border-color: #78c3f3;
  color: #004974;
  text-decoration: none;
}
.item-label {
  background-color: #e9e9e9;
  padding: 8px;
  line-height: 1.5rem;
}
.item-label .mint-button {
  float: right;
  height: 1.5rem;
}
.item-del {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: url("../assets/del.png") no-repeat;
}
</style>